import { graphql } from 'gql'

export const UPDATE_WORKSPACE_GENERAL_CONFIGURATION = graphql(`
  mutation updateWorkspaceGeneralConfiguration($input: UpdateWorkspaceGeneralConfigurationInput!) {
    updateWorkspaceGeneralConfiguration(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
